import { IUsuarioRol } from '../usuarioRol';

export interface IPaisSnp {
  clave?: string;
  nombre?: string;
}

export class PaisSnp implements IPaisSnp {
  constructor(public clave?: string, public nombre?: string) {}
}
export interface ISedeSnp {
  claveSede?: string;
  sede?: string;
  clavePais?: string;
  pais?: string;
  claveEntidadFederativa?: string;
  entidadFederativa?: string;
  claveMunicipio?: string;
  municipio?: string;
  claveDependencia?: string;
  nombreDependencia?: string;
  reniecytSede?: string;
  reniecytDependencia?: string;
  activo?: boolean;
  postulante?: boolean;
  esInstitucion?: boolean;
}

export class SedeSnp implements ISedeSnp {
  constructor(
    public claveSede?: string,
    public sede?: string,
    public clavePais?: string,
    public pais?: string,
    public claveEntidadFederativa?: string,
    public entidadFederativa?: string,
    public claveMunicipio?: string,
    public municipio?: string,
    public claveDependencia?: string,
    public nombreDependencia?: string,
    public reniecytSede?: string,
    public reniecytDependencia?: string,
    public activo?: boolean,
    public postulante?: boolean,
    public esInstitucion?: boolean
  ) {}

  static fromObject(object: ISedeSnp): SedeSnp {
    return Object.assign(new SedeSnp(), object);
  }
}

export interface IInstitucionSnp {
  id?: string;
  rfc?: string;
  claveInstitucion?: string;
  nombreInstitucion?: string;
  clavePais?: string;
  pais?: string;
  claveEntidadFederativa?: string;
  entidadFederativa?: string;
  claveMunicipio?: string;
  municipio?: string;
  reniecyt?: string;
  activo?: boolean;
  sector?: string;
  postulante?: boolean;
  sedes?: ISedeSnp[];
}

export class InstitucionSnp implements IInstitucionSnp {
  constructor(
    public id?: string,
    public rfc?: string,
    public claveInstitucion?: string,
    public nombreInstitucion?: string,
    public clavePais?: string,
    public pais?: string,
    public claveEntidadFederativa?: string,
    public entidadFederativa?: string,
    public claveMunicipio?: string,
    public municipio?: string,
    public reniecyt?: string,
    public activo?: boolean,
    public sector?: string,
    public postulante?: boolean,
    public sedes?: ISedeSnp[]
  ) {
    if (!sedes) {
      this.sedes = [];
    }
  }

  static fromObject(object: IInstitucionSnp): InstitucionSnp {
    return Object.assign(new InstitucionSnp(), object);
  }
}

export interface IInstitucionConSedeSeleccion {
  institucion?: InstitucionSnp;
  sede?: ISedeSnp;
}

export class InstitucionConSedeSeleccion {
  constructor(public institucion?: InstitucionSnp, public sede?: ISedeSnp) {}
}
